<script>
    import { db, storage } from '../../../firebase';
    import { user, profileData } from '../../../store';
    import { updateBookmark } from '../../../helpers/bookmark';
    import { link } from 'svelte-spa-router'
    // import { Image } from 'svelte-lazy-loader'

    import Egg from '../../atoms/Egg.svelte';
    import Icon from '../../atoms/Icon.svelte';
    import heart from '../../../../public/assets/svg/24/heart.svg';
    import chat from '../../../../public/assets/svg/24/chat.svg';
    import remove from '../../../../public/assets/svg/24/remove.svg';

    export let uid;
    export let page;

    export let docId; // document ID
    export let title;
    export let text;
    export let timestamp;
    export let media;
    export let isSecured;
    export let saveCount;
    export let messageCount;

    // releveant for cardStack
    export let cardStackStatus = null;
    export let isDragging = null;

    let thisCard;    
    let isSaved;
    let saving = false;
    let urlOpenInChatTab = false;
    let modalUrl;

    $: if ($profileData && $profileData.saved) {
        isSaved = $profileData.saved.includes(docId) ? true : false;
    };

    $: absolutePath = media && getAbsolutePath();
    $: authorData = uid && getAuthorData();

    $: cardStackStatus && thisCard && updateCardStackStatus();

    function getAuthorData() {
        db.collection('users').doc(uid).get().then((doc)=> {                             
            authorData = doc.data();
        }).catch((error)=> {error});
    }

    function getAbsolutePath() {
        const storageRef = storage.ref();
        storageRef.child(media).getDownloadURL().then((url) => { 
            absolutePath = url;
        });
    }

    // function updateStatus() {
    //  let newStatus = !isPublic;
	// 	db.collection('ideas').doc(id).update({ isPublic: newStatus });
    // }

    async function bookmarkHanlder(update, user, docId) {
        if(saving) return;
        saving = true;
        if(page === 'vault' && update === 'remove') {
            if (window.confirm("Remove this idea from your liked list?")) {
                await updateBookmark(update, user, docId)
            }
        }else {
            await updateBookmark(update, user, docId)
        }
        saving = false;
    }

	function removeItem() {
        if(window.confirm('Are you sure you want to delete this draft?')) {
            db.collection('ideas').doc(docId).delete();
            // Todo, delete idea from User collection as well!
            deleteImage(media);
        }
    }

    function deleteImage(media) {
        // delete an image from the cloud storage
        if(media) {
            const storageRef = storage.ref();
            var image = storageRef.child(media);
            image.delete().then(function() {
                console.log('Image deleted successfully')
            }).catch(function(error) {
                console.log('Image NOT deleted', error)
            });
        }
    }

    // reset position when going back
    function updateCardStackStatus() {
        setTimeout(() => {
            if(cardStackStatus === 'current') {
                thisCard && thisCard.removeAttribute('style');
            }
        })
    }

    $: modalUrl = urlOpenInChatTab ? `/idea/${docId}?chat` : `/idea/${docId}`;

</script>

<style lang="scss" src="./Card.scss"></style>

<div class="card__wrapper{page === 'feed' ? ' is-big' : ''}" bind:this={thisCard} data-dragging="{isDragging}" data-status="{cardStackStatus}">
    <a class="card{!isSecured ? ' is-draft' : ''}" href={modalUrl} use:link>
        <div class="card__image__wrapper">
            {#if media && absolutePath}
                <div class="card__image">
                    <!-- <Image loading="lazy" src="{absolutePath}" alt="{title}" /> -->
                    <img src="{absolutePath}" alt="{title}" loading="lazy">
                </div>
            {/if}
            <div class="card__egg">
                <Egg letter={title.charAt(0)} cssClass={page === 'feed' ? ' is-big' : ''}></Egg>                
            </div>
        </div>
        <div class="card__content">
            <div class="card__text">
                <div class="card__text__inner">
                    <h2 class="card__title">{title}</h2>
                </div>
                <div class="card__meta">
                    {#if authorData}
                        <small class="card__created">by {authorData.name}</small>
                    {/if}
                    <div class="card__interactions">
                        {#if isSecured}
                            <button class="card__interaction" class:bookmark--saving={saving} on:click|stopPropagation|preventDefault={() => bookmarkHanlder(isSaved ? 'remove' : 'add', $user, docId)}>
                                <Icon cssClass={'card__interaction'} data={heart} size={'22px'} stroke={'#341153'} fill={isSaved ? '#341153': 'none'}></Icon>                        
                                <small>{saveCount ?? 0}</small>
                            </button>
                            <button class="card__interaction" on:click={() => urlOpenInChatTab = true}>
                                <Icon cssClass={'card__interaction'} data={chat} stroke={'#341153'} fill={"none"}></Icon>
                                <small>{messageCount ?? 0}</small>
                            </button>
                        {:else}
                            <button class="card__delete" on:click|stopPropagation|preventDefault={removeItem}>
                                <Icon cssClass={'card__delete'} data={remove} stroke="#341153" fill={'none'}></Icon>
                            </button>
                        {/if}
                    </div>
                </div>
            </div>
        </div>
    </a>
</div>